import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';

import { Tabs, Typography } from 'antd';

import TabInvites from '@/components/shared/Notifications/TabInvites';
import TabUpdates from '@/components/shared/Notifications/TabUpdates';
import PageTitle from '@/components/shared/PageTitle';
import Wrapper from '@/components/shared/Wrapper';
import { setNotification } from '@/redux/notification/slice';
import styled, { css, StyledProp } from '@/styled';

import NotificationItem from '../Notifications/NotificationItem';

const items = [
  {
    label: 'Novidades',
    key: '1',
    children: <TabUpdates />
  },
  {
    label: 'Convites',
    key: '2',
    children: <TabInvites />
  }
];

const NotificationCenter = ({ className }: StyledProp) => {
  const dispatch = useDispatch();

  const handleClickTab = () => {
    dispatch(setNotification(null));
  };

  return (
    <Wrapper size='large' className={className}>
      <PageTitle
        title=''
        breadcrumbItems={[{ title: <Link to='/resumo'>Resumo</Link> }, { title: 'Central de Notificações' }]}
        className='bread-crumbs'
      />
      <div className='container'>
        <div className='tab-container'>
          <Typography.Title className='title' level={3}>
            Central de Notificações
          </Typography.Title>
          <Tabs className='tabs' items={items} onChange={handleClickTab} />
        </div>
        <NotificationItem />
      </div>
    </Wrapper>
  );
};

const StyledNotificationCenter = styled(NotificationCenter)`
  position: relative;
  max-width: 100%;

  ${({ theme }) => css`
    ${theme.breakpoints.down('sm')} {
      padding: 0;
    }

    .bread-crumbs {
      ${theme.breakpoints.down('sm')} {
        display: none;
      }
    }

      .image {
       z-index: 0;
     }


    .container {
      position: relative;
      max-width: 100%;
      display: flex;
      flex-direction: row;
      overflow: hidden;

      ${theme.breakpoints.down('lg')} {
        height: 100%;
      }

      .tab-container {
        border: 1px solid ${theme.palette.gray[8]};
      }

      .tab-container + div {
        &[data-empty='true'] {
          display: flex;
          justify-content: center;
          align-items: center;
          > {
            padding 0;
          }
        }
      }

      > div > .title {
        font-weight: 400;
        padding: ${theme.space.spacing(4, 6)};
        border-radius: 4px;
        border-bottom-width: 0;
      }

      > div {
        ${theme.breakpoints.down('lg')} {
          min-width: 100%;
        }
      }

      .showAll {
        display: none;
      }

      .tabs {
        min-height: 100%;
        border: 1px solid ${theme.palette.gray[8]};
        border-top-width: 0;
        border-radius: 4px;

        .ant-tabs-nav {
          background: ${theme.variables.tabs.headerBackground};
          padding: ${theme.space.spacing(0, 6)};
          color: ${theme.colorTextSecondary};
          box-shadow: none;
          margin: 0;

          &::before {
            border-bottom: 0;
          }

          .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
            color: ${theme.colorTextBase};
          }
        }
      }
    }
  `}
`;

export default StyledNotificationCenter;
